<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { useI18n } from "vue-i18n"
import { inject, computed } from "vue"

const { t } = useI18n()
const urls = inject("urls")

const agbText = computed(() => {
  return t("shopping.purchase.agb_condition")
    .replace("AGB_LINK", urls.urlTerms)
    .replace("WIDERRUF_LINK", urls.urlWithdraw)
})
const privacyText = computed(() => {
  return t('shopping.purchase.privacy_policy')
    .replace("PRIVACY_LINK", urls.urlPrivacy)
})
</script>
